import { TokenAmount } from "@/components/brand/TokenAmount";
import { MetricsSourceBadge } from "@/components/ui/MetricsSourceBadge";
import { useCertifiedAnalytics } from "@/hooks/useCertifiedAnalytics";
import { ROUTES } from "@/lib/routes";
import { formatNum } from "@/lib/utils";
import { Link } from "react-router-dom";

/** Bottom row: key protocol metrics (live queries; Certified = IC digest). */
export function ProtocolStatusRow() {
	const { data: stats, isLoading } = useCertifiedAnalytics();
	const blank = stats?.source === "unverified";

	return (
		<div className="border-t border-border bg-card/90">
			<div className="container mx-auto flex flex-wrap items-center gap-x-4 gap-y-2 px-3 py-2.5 sm:px-4">
				<div className="flex items-center gap-2">
					<span className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
						Protocol status
					</span>
					<MetricsSourceBadge source={stats?.source} />
				</div>

				{isLoading ? (
					<span className="text-xs text-muted-foreground">Loading…</span>
				) : (
					<div className="flex min-w-0 flex-1 flex-wrap items-center gap-x-3 gap-y-1 text-xs">
						<span className="font-mono-amount">
							<span className="text-muted-foreground">TVL </span>
							{blank ? "—" : `$${formatNum(stats?.tvlUsd ?? 0, 0)}`}
						</span>
						<span className="inline-flex items-center gap-1">
							<span className="text-muted-foreground">Debt</span>
							{blank ? (
								"—"
							) : (
								<TokenAmount
									id="USDM"
									value={stats?.totalDebtUsd ?? 0}
									decimals={0}
									size="sm"
								/>
							)}
						</span>
						<span className="font-mono-amount">
							<span className="text-muted-foreground">Vaults </span>
							{blank ? "—" : (stats?.activeVaults ?? 0)}
						</span>
						<span className="font-mono-amount text-warning">
							<span className="text-muted-foreground">At risk </span>
							{blank ? "—" : (stats?.atRiskCount ?? 0)}
						</span>
					</div>
				)}

				<div className="hidden gap-2 text-[11px] font-semibold sm:flex">
					<Link to={ROUTES.analytics} className="text-primary hover:underline">
						Analytics
					</Link>
					<Link to={ROUTES.oracle} className="text-primary hover:underline">
						Oracle Layer
					</Link>
				</div>
			</div>
		</div>
	);
}
